import { u as f } from "./chunk-DMO4EI7P-70e4c539.js";
import { f as y, o as b, c as x, a as o } from "./chunk-KRPLQIP4-1ae0870d.js";
import { keyframes as h } from "@emotion/react";
import { j as a } from "./jsx-runtime-721af1ab.js";
var u = h({
  "0%": {
    transform: "rotate(0deg)"
  },
  "100%": {
    transform: "rotate(360deg)"
  }
}), S = y((r, n) => {
  const t = f("Spinner", r), {
    label: e = "Loading...",
    thickness: i = "2px",
    speed: l = "0.45s",
    emptyColor: s = "transparent",
    className: m,
    ...d
  } = b(r), p = x("chakra-spinner", m), c = {
    display: "inline-block",
    borderColor: "currentColor",
    borderStyle: "solid",
    borderRadius: "99999px",
    borderWidth: i,
    borderBottomColor: s,
    borderLeftColor: s,
    animation: `${u} ${l} linear infinite`,
    ...t
  };
  return /* @__PURE__ */ a.jsx(
    o.div,
    {
      ref: n,
      __css: c,
      className: p,
      ...d,
      children: e && /* @__PURE__ */ a.jsx(o.span, { srOnly: !0, children: e })
    }
  );
});
S.displayName = "Spinner";
export {
  S
};
